// extracted by mini-css-extract-plugin
export var contrastLow = "_32-1";
export var externalLink = "_32-2";
export var externalLinkIcon = "_32-3";
export var link = "_32-0";
export var linkLabel = "_32-4";